
import React, { useMemo } from 'react';

import { useAdress } from '../../../helpers/api/users/users';
import UltrasoundAnimation from './ultrasound-animation';

const extractSubdomain = (hostname: string) => {
  // If running on localhost, treat as if on dev.deepecho.io
  let effectiveHostname = hostname;
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0'
  ) {
    effectiveHostname = 'dev.deepecho.io';
  }
  // e.g. sub.example.com -> sub
  // e.g. dev.deepecho.io -> dev
  // e.g. localhost or IP -> ''
  const parts = effectiveHostname.split('.');
  if (parts.length > 2) {
    return parts[0];
  }
  return '';
};

interface StaticIp {
  name: string;
  address: string;
  region: string;
  status: string;
}

const TestPage: React.FC = () => {
  // Get subdomain from window.location.hostname
  const subdomain = useMemo(() => {
    if (typeof window !== 'undefined') {
      return extractSubdomain(window.location.hostname);
    }
    return '';
  }, []);

  const { data, isLoading, error } = useAdress(subdomain);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Test Page</h1>
      <p>
        This is a sample component to test infra changes. <br />
        The content of this page may be updated frequently. <br />
        test - abdou i am tetsing staging 08/09 frontend
      </p>

      <div style={{ margin: '1rem 0' }}>
        <strong>Subdomain detected:</strong> {subdomain || '(none)'}
      </div>

      {isLoading && (
        <div style={{ color: '#888', margin: '1rem 0' }}>Loading...</div>
      )}

      {error && (
        <div style={{ color: 'red', margin: '1rem 0' }}>
          Error: {error.message || 'An error occurred.'}
        </div>
      )}

      {data && (
        <div
          style={{
            marginTop: '1rem',
            textAlign: 'left',
            maxWidth: 800,
            margin: '1rem auto',
          }}
        >
          {data.data &&
            data.data.static_ips &&
            Array.isArray(data.data.static_ips) && (
              <div style={{ marginTop: '1rem' }}>
                <h4>Static IPs ({data.data.total_count})</h4>
                <ul>
                  {data.data.static_ips.map((ip: StaticIp, idx: number) => (
                    <li key={idx}>
                      <strong>{ip.name}</strong> - {ip.address} ({ip.region}) [
                      {ip.status}]
                    </li>
                  ))}
                </ul>
              </div>
            )}
        </div>
      )}

      {/* Ultrasound Animation Component */}
      <div style={{ marginTop: '3rem' }}>
        <h2>Ultrasound Animation Demo</h2>
        <UltrasoundAnimation />
      </div>
    </div>
  );
};

export default TestPage;
